import { useEffect, useRef } from 'react';

// ─── useScrollToTopOnFormOpen ─────────────────────────────────────────────────
// Scrolls the window to top on the false→true transition of `isFormOpen`.
// The previous value is held in a useRef so re-renders that keep the form
// open do not re-trigger the scroll. Idempotent on no-op renders.
export default function useScrollToTopOnFormOpen(isFormOpen) {
  const prevRef = useRef(false);
  useEffect(() => {
    if (isFormOpen && !prevRef.current) {
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
    prevRef.current = isFormOpen;
  }, [isFormOpen]);
}
